import { render, staticRenderFns } from "./ComplianceResult.vue?vue&type=template&id=656f3cab"
import script from "./ComplianceResult.vue?vue&type=script&lang=js"
export * from "./ComplianceResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports